import { Button, Form, Input, Modal, Row, Select, Spin } from "antd";
import { saleService } from "modules/sale-staff/service";
import React from "react";
import { FIVE, MOBI, SEVEN, VIETTEL, VINA, toNonAccentVietnamese } from "utils";

interface IAddCustomerModal {
    visible: boolean;
    loading: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    onCreateCustomer: (values: any) => Promise<void>;
}

const AddCustomerModal = (props: IAddCustomerModal) => {
    const { visible, setVisible, onCreateCustomer, loading } = props;
    const [form] = Form.useForm();
    const [provinces, setProvinces] = React.useState<any[]>([]);
    const [districts, setDistricts] = React.useState<any[]>([]);
    const [wards, setWards] = React.useState<any[]>([]);
    const [provinceId, setProvinceId] = React.useState<any>();
    const [districtId, setDistrictId] = React.useState<any>();

    const onCancel = () => setVisible(false);

    const onGetProvinces = async () => {
        try {
            const res: any = await saleService.getProvinces();
            if (res?.status) {
                const data = res?.data?.map((item: any) => ({ ...item, value: item?.id, label: item?.name }));
                setProvinces(data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const onGetDistricts = async () => {
        try {
            const payload = {
                province_id: form.getFieldValue("province"),
            };
            const res: any = await saleService.getDistricts(payload);
            if (res?.status) {
                const data = res?.data?.map((item: any) => ({ ...item, value: item?.id, label: item?.name }));
                setDistricts(data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const onGetWards = async () => {
        try {
            const payload = {
                district_id: form.getFieldValue("district"),
            };
            const res: any = await saleService.getWards(payload);
            if (res?.status) {
                const data = res?.data?.map((item: any) => ({ ...item, value: item?.id, label: item?.name }));
                setWards(data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const onFinish = (values: any) => onCreateCustomer(values);

    React.useEffect(() => {
        onGetProvinces();
    }, []);

    React.useEffect(() => {
        if (provinceId) {
            onGetDistricts();
        }
    }, [provinceId]);

    React.useEffect(() => {
        if (districtId) {
            onGetWards();
        }
    }, [districtId]);

    return (
        <Modal width={700} centered title="Thêm khách hàng mới" visible={visible} onCancel={onCancel} footer={null}>
            <Spin spinning={loading}>
                <Form
                    form={form}
                    labelCol={{ span: 5 }}
                    wrapperCol={{ span: 18 }}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <br />
                    <Form.Item
                        name={"name"}
                        label="Tên khách hàng"
                        rules={[{ required: true, message: "Vui lòng nhập tên khách hàng!" }]}
                    >
                        <Input allowClear placeholder="Nhập tên khách hàng" />
                    </Form.Item>
                    <Form.Item
                        name={"phone"}
                        label="Số điện thoại"
                        rules={[
                            { required: true, message: "Vui lòng nhập số điện thoại!" },
                            {
                                message: "Số điện thoại không hợp lệ!",
                                validator: (_, value) => {
                                    if (!value?.toString()?.trim()) return Promise.resolve();
                                    if (
                                        (!value?.toString()?.match(SEVEN) &&
                                            !value?.toString()?.match(MOBI) &&
                                            !value?.toString()?.match(VIETTEL) &&
                                            !value?.toString()?.match(VINA) &&
                                            !value?.toString()?.match(FIVE)) ||
                                        isNaN(Number(value))
                                    ) {
                                        return Promise.reject();
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        <Input
                            onChange={(e: any) => {}}
                            placeholder="Nhập số điện thoại"
                            allowClear
                            autoComplete="off"
                        />
                    </Form.Item>
                    <Form.Item
                        name={"province"}
                        label="Tỉnh/thành phố"
                        rules={[{ required: true, message: "Vui lòng chọn tỉnh, thành phố!" }]}
                    >
                        <Select
                            options={provinces}
                            allowClear
                            showArrow
                            placeholder="Chọn tỉnh/thành phố"
                            showSearch
                            onChange={(value: any) => {
                                setProvinceId(value);
                                setDistrictId(undefined);
                                form.setFieldsValue({
                                    district: undefined,
                                    ward: undefined,
                                });
                            }}
                            filterOption={(input, option: any) => {
                                const nonAccent = toNonAccentVietnamese(option?.label).toLowerCase();
                                const nonAccentInput = toNonAccentVietnamese(input).toLowerCase();
                                return nonAccent.includes(nonAccentInput);
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name={"district"}
                        label="Quận/huyện"
                        rules={[{ required: true, message: "Vui lòng chọn quận, huyện!" }]}
                    >
                        <Select
                            options={districts}
                            allowClear
                            showArrow
                            placeholder="Chọn quận/huyện"
                            showSearch
                            disabled={!provinceId}
                            onChange={(value: any) => {
                                setDistrictId(value);
                                form.setFieldsValue({
                                    ward: undefined,
                                });
                            }}
                            filterOption={(input, option: any) => {
                                const nonAccent = toNonAccentVietnamese(option?.label).toLowerCase();
                                const nonAccentInput = toNonAccentVietnamese(input).toLowerCase();
                                return nonAccent.includes(nonAccentInput);
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name={"ward"}
                        label="Phường/xã"
                        rules={[{ required: true, message: "Vui lòng chọn phường, xã!" }]}
                    >
                        <Select
                            options={wards}
                            allowClear
                            showArrow
                            placeholder="Chọn phường/xã"
                            showSearch
                            disabled={!districtId}
                            filterOption={(input, option: any) => {
                                const nonAccent = toNonAccentVietnamese(option?.label).toLowerCase();
                                const nonAccentInput = toNonAccentVietnamese(input).toLowerCase();
                                return nonAccent.includes(nonAccentInput);
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name={"address"}
                        label="Địa chỉ cụ thể"
                        rules={[{ required: true, message: "Vui lòng nhập địa chỉ cụ thể!" }]}
                    >
                        <Input allowClear placeholder="Nhập địa chỉ cụ thể" />
                    </Form.Item>
                    <Row justify="end" style={{ marginTop: 20, borderTop: "1px solid #efeeee", paddingTop: 20 }}>
                        <Button type="default" onClick={onCancel}>
                            Huỷ
                        </Button>
                        <Form.Item>
                            <Button
                                htmlType="submit"
                                type="primary"
                                style={{ background: "green", marginLeft: 10 }}
                                loading={loading}
                            >
                                Lưu
                            </Button>
                        </Form.Item>
                    </Row>
                </Form>
            </Spin>
        </Modal>
    );
};

export default AddCustomerModal;
